/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { setTimeSheetLoader } from '../../../../infra/aggregates/myProfile/AttendanceAggregates/getEmpTimeSheetSlice';
import moment from 'moment';
import { shiftAndScheduleService } from '../../../../api/services/shiftAndScheduleService';
import { setAllShiftListsData } from '../../../../infra/aggregates/myProfile/shiftAndScheduleAggregates/allShiftsLists';

interface PropsValues {
  setShiftScheduleList: (data: any) => void;
}

function DTOShiftAndScheduleList({ setShiftScheduleList }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);

  const storedShiftLists = useAppSelector(
    (state) => state.allShiftsLists.shiftLists,
  );

  const dispatch = useAppDispatch();

  async function getAllShiftsData(
    empId: number,
    page: number,
    fromDate: string,
    toDate: string,
  ) {
    dispatch(setTimeSheetLoader(true));
    const response: any = await shiftAndScheduleService.getAllShifts(
      empId,
      page,
      fromDate,
      toDate,
    );
    if (response.response == 'success') {
      dispatch(setAllShiftListsData(response.data));

      setShiftScheduleList(response.data);
      dispatch(setTimeSheetLoader(false));
    } else {
      dispatch(setTimeSheetLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id) {
      const _startDate = moment()
        .add('months')
        .startOf('month')
        .format('YYYY-MM-DD');
      const _lastDate = moment()
        .add('months')
        .endOf('month')
        .format('YYYY-MM-DD');

      getAllShiftsData(selector.emp_id, 0, _startDate, _lastDate);
    }
  }, []);

  useEffect(() => {
    if (selector.emp_id) {
      const _startDate = moment()
        .add('months')
        .startOf('month')
        .format('YYYY-MM-DD');
      const _lastDate = moment()
        .add('months')
        .endOf('month')
        .format('YYYY-MM-DD');

      getAllShiftsData(selector.emp_id, 0, _startDate, _lastDate);
    }
  }, []);

  useEffect(() => {
    setShiftScheduleList(storedShiftLists);
  }, [storedShiftLists]);
  return <></>;
}
export default DTOShiftAndScheduleList;
